export abstract class AbstractLearnCourseActionService {
    public abstract bookmarkCourse(courseId: string, isBookmarked: boolean): void;
    public abstract likeCourse(courseId: string, isLiked: boolean): void;
    public abstract enrollForCourse(courseId: string, enrollmentStatus: number): void;  
    public abstract removeFromCart(courseId: string, enrollmentStatus: number): void;
    public abstract showInterestCourse(courseId: string, isShowInterest: boolean): void;
}